import React from 'react'
import styled from 'styled-components'
import { SectionWithTitle } from 'components/SectionWithTitle/SectionWithTitle'
import { CategoryTile } from './CategoryTile'
import { breakpointUpTo } from 'utils/breakpoints'
import { ICategoryTileData } from '../../../graphql/types'

const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space[4]};
  justify-content: center;

  > * {
    flex: 0 1 ${({ theme }) => `calc((100% - 3 * ${theme.space[4]}) / 4)`};

    ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
      flex-basis: ${({ theme }) => `calc((100% - ${theme.space[4]}) / 2)`};
    }
  }
`

export type CategoriesSectionProps = {
  title: string
  categories: ICategoryTileData[]
  pathnamePrefix?: string
}

export const CategoriesSection = ({
  title,
  categories,
  pathnamePrefix,
}: CategoriesSectionProps) => {
  return (
    <SectionWithTitle title={title}>
      <StyledContainer>
        {categories.map(({ id, name, pathname, ...rest }) => (
          <CategoryTile
            key={id}
            heading={name}
            pathname={
              pathnamePrefix ? `${pathnamePrefix}/${pathname}` : pathname
            }
            {...rest}
          />
        ))}
      </StyledContainer>
    </SectionWithTitle>
  )
}
